import * as API_PAGE from '../../api/page'

export default {
  namespaced: true,
  state: {
    menuList: [],
    url: '',
    underWriterList: []
  },
  mutations: {
    modelMenu(state, payload) {
      state.menuList = payload.menuList
      localStorage.setItem('id', state.menuList[1].id)
      localStorage.setItem('helpId', state.menuList[4].id)
    },
    GoToBackendUrl(state, payload) {
      state.url = payload.url
    },
    setUnderWriterList(state, list) {
      state.underWriterList = list
    }
  },
  actions: {
    modelMenu(context) {
      return API_PAGE.getMenu({ isNavigation: 1, status: 0 }).then(res => {
        context.commit('modelMenu', {
          menuList: res.data
        })
      })
    },
    GoToBackendUrl(context) {
      return API_PAGE.getGoToBackendUrl('cmsGoToUrl').then(res => {
        context.commit('GoToBackendUrl', {
          url: res.data
        })
      })
    },
    setUnderWriterList(context,list){
      context.commit('setUnderWriterList',list)
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/page.js